// extracted by mini-css-extract-plugin
module.exports = {"subtitle":"BasicHeader_subtitle__24fsE","container":"BasicHeader_container__1DWTS","title":"BasicHeader_title__4hd-r"};